import { AnyAction } from 'redux';

import { TNC_REQUESTED, TNC_RECEIVED, TNC_FAILED, TNC_RECEIVE_DONE } from '@ttstr/actions';
import { IndexedTNCs } from '@ttstr/api';
import { AppState } from '.';

export interface ReduxState {
  catalogReceived: boolean;
  extra_tncs: IndexedTNCs;
}

const initialState: ReduxState = {
  catalogReceived: false,
  extra_tncs: {},
};

const Catalog = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case TNC_RECEIVED: {
      const { tnc } = action.payload;

      return {
        ...state,
        extra_tncs: { ...state.extra_tncs, [tnc.id]: tnc }
      };
    }
    default:
      return state;
  }
};

export default Catalog;
